import { Box, Button, Card, Divider, Stack, Typography } from "@mui/material";
import { Edit } from "@mui/icons-material";
import { ShippingAddress } from "../../types";
import { useTranslation } from "../../../../hooks/useTranslation";

type Props = {
  shippingAddress?: ShippingAddress;
  onEdit: () => void;
};

export const BuyerInfoCard = ({ shippingAddress, onEdit }: Props) => {
  const { translate } = useTranslation("pages.orderDetails");

  return (
    <Card
      elevation={0}
      sx={{
        p: 2,
        backgroundColor: (theme) => theme.palette.customBackground.box,
        borderLeft: "3px solid",
        borderColor: "secondary.main",
      }}
    >
      {/* HEADER */}
      <Stack direction="row" alignItems="center">
        <Typography variant="subtitle1" fontWeight={500}>
          {translate("buyerInfo.title")}
        </Typography>
        <Box flex={1} />
        <Button
          size="small"
          variant="outlined"
          startIcon={<Edit fontSize="small" />}
          onClick={onEdit}
        >
          {translate("addressEdit.button")}
        </Button>
      </Stack>

      <Divider sx={{ my: 1 }} />

      {/* CONTENT – LABEL / VALUE */}
      <Stack spacing={1}>
        <Box display="flex">
          <Box width={120}>
            <Typography variant="body2" fontWeight={500}>
              {translate("buyerInfo.name")}
            </Typography>
          </Box>
          <Typography variant="body2">
            {shippingAddress?.name ?? "-"}
          </Typography>
        </Box>

        <Box display="flex">
          <Box width={120}>
            <Typography variant="body2" fontWeight={500}>
              {translate("buyerInfo.phone")}
            </Typography>
          </Box>
          <Typography variant="body2">
            {shippingAddress?.phone ?? "-"}
          </Typography>
        </Box>

        <Box display="flex">
          <Box width={120}>
            <Typography variant="body2" fontWeight={500}>
              {translate("buyerInfo.address")}
            </Typography>
          </Box>
          <Typography variant="body2">
            {[
              shippingAddress?.addressLine1,
              shippingAddress?.addressLine2,
              shippingAddress?.city,
              shippingAddress?.stateOrRegion,
              shippingAddress?.countryCode,
            ]
              .filter(Boolean)
              .join(", ") || "-"}
          </Typography>
        </Box>
      </Stack>
    </Card>
  );
};
